import React, { FC } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Grid,
  TextField,
  FormHelperText,
  DialogActions,
  Button,
  Divider,
} from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ExternalCode } from '../interfaces';
import { Autocomplete } from '@material-ui/lab';
import { translate } from '../../../utils/helpers';

interface Props {
  handleClose: () => void;
  open: boolean;
  submit: (values: ExternalCode) => void;
  marketPlaceList: string[]
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  })
);

const ExternalCodeModal: FC<Props> = ({
  handleClose,
  open,
  submit,
  marketPlaceList
}: Props): React.ReactElement => {
  const { handleSubmit, errors, register, control, setValue } = useForm();
  const classes = useStyles();

  const submitFrom = (values: ExternalCode) => {
    submit(values);
  };

  return (
    <Dialog
      // fullWidth
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      open={open}
    >
      <form onSubmit={handleSubmit(submitFrom)}>
        <DialogContent style={{ padding: '24px' }}>
          <Grid container spacing={3}>
            <Grid container item xs={12} >
              <div className={classes.item}>
                <div style={{ width: '100%' }}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="marketplaceType"
                    label="نام فروشنده/تامین‌کننده"
                    render={({ onChange }) => (
                      <Autocomplete
                        id="marketplaceType"
                        noOptionsText="موردی یافت نشد"
                        getOptionSelected={(option, value) =>
                          option === value
                        }
                        onChange={(_, newValue: any) => {
                          setValue('marketplaceType', newValue)
                        }}
                        options={marketPlaceList}
                        getOptionLabel={options => translate(options)}
                        renderInput={params => (
                          <TextField
                            variant="outlined"
                            {...params}
                            style={{ marginTop: 0, marginBottom: 0 }}
                            margin="normal"
                            label="پلتفرم"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.marketplaceType && 'ویژگی الزامی میباشد'}
                  </FormHelperText>
                </div>
              </div>
            </Grid>
            <Grid container item xs={12} >
              <div className={classes.item}>
                <div style={{ width: '100%' }}>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    id="externalCode"
                    name="externalCode"
                    label="کد"
                    inputRef={register({
                      required: true,
                    })}
                    error={errors.externalCode && true}
                  />
                  <FormHelperText error focused>
                    {errors.externalCode && 'کد الزامی میباشد'}
                  </FormHelperText>
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: '24px', marginTop: "50px" }}>
          <Grid
            container
            spacing={2}
            justifyContent="flex-end"
            style={{ textAlign: 'left' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ marginLeft: '8px' }}
                type="submit"
                variant="contained"
                color="primary"
                size="large"
              >
                {`ایجاد`}
              </Button>
              <Button onClick={handleClose} variant="outlined" size="large">
                {`انصراف`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ExternalCodeModal;
